import React, { useEffect, useState } from 'react';
import { CompraRecusada } from '../pages/compra-recusada/compra-recusada';
import { Sell } from '../../common/types/venda';
import { useLocation, useNavigate } from 'react-router-dom';

export const CompraRecusadaTemplate = () => {
  const [venda, setVenda] = useState<Sell>({} as Sell);
  const navigate = useNavigate();
  const location = useLocation();
  useEffect(() => {
    if (!location?.state?.purchase) {
      window.location.href = 'https://vendepay.com.br';
    } else {
      setVenda(location?.state?.purchase);
    }
  }, []);
  return (
    <CompraRecusada
      onRetry={() =>
        navigate(
          {
            pathname: `/${venda?.produtoId}`,
            search: location.search,
          },
          { state: { paymentDeclined: true } },
        )
      }
    />
  );
};
